(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:Phase
   *
   * @description
   *
   */
  angular
      .module('neo.services')
      .factory('InvoiceRef', InvoiceRef);

  function InvoiceRef($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/invoiceref/:Id', {id: '@_Id'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());


